<template lang="pug">
.mask-container(
  v-if="show"
)
  transition(name="fade")
    .mask
      slot
</template>
<script>
export default {
  name: 'GbMask',
  props: {
    show: {
      type: Boolean,
      defalt: false
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '../../stylus/main.styl'
.mask-container
  position fixed
  top 0
  right 0
  bottom 0
  left 0
  z-index 100
.mask
  position absolute
  top 0
  right 0
  bottom 0
  left 0
  background-color rgba(0, 0, 0, .75)
  display flex
  justify-content center
  align-items center
</style>



// WEBPACK FOOTER //
// src/components/atoms/GbMask.vue